module.exports = __webpack_public_path__ + "static/media/13-video2.4052b89d.png";